// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"858920bf","945":"233c3338"}[chunkId] + ".chunk.css";
};